var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,145.217v336.005h512V145.217H0z M480,252.929H304.005v32H480v164.292H32V284.93h176.003v-32H32v-75.712H480 V252.929z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.558,79.528c10.406-10.375,24.602-16.743,40.446-16.75c15.844,0.007,30.04,6.375,40.446,16.75 c10.374,10.398,16.742,24.594,16.75,40.454h32.001c-0.008-49.282-39.93-89.198-89.197-89.205 c-49.266,0.007-89.188,39.922-89.196,89.205h32C198.816,104.122,205.183,89.926,215.558,79.528z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.004,
    y: 240.452,
    className: "st0",
    width: 48.001,
    height: 64.001
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.6ff94adb36e09f1def5f7450eeee4802.svg";
export { ForwardRef as ReactComponent };